import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { HttpClient, HttpHeaders }  from '@angular/common/http';
import { Router } from '@angular/router';
import { API_BASE_URL } from '../../environments/environment';
import { MatTableDataSource, MatPaginator, MatDatepickerInputEvent } from '@angular/material';
import { FormControl } from '@angular/forms';
import moment from 'moment';

export interface Log {
  day: string;
  createdTime: string;
  userId: string;
  userName: string;
  serviceName: string;
  operation: string;
  logText: string;
}

@Component({
  selector: 'app-log',
  templateUrl: './log.component.html',
  styleUrls: ['./log.component.less']
})
export class LogComponent implements OnInit, AfterViewInit {

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  // テーブルデータソース
  logList = new MatTableDataSource();

  // 記録日
  startDay = new FormControl(new Date(moment().add(-6, 'days').format('YYYY/MM/DD')));
  endDay = new FormControl();
  startRecordDay = '';
  endRecordDay = '';

  // チェックボックス　エラーのみ
  error: boolean = false;

  // 日付
  day = '';

  // 時間
  time = '';

  // ユーザー（メールアドレスかユーザー名）
  userId = '';

  // サービス名
  serviceName = '';

  // 操作カテゴリ
  operation = '';

  // 詳細
  logText = '';

  // データ件数
  dataSourceLength = 0;

  // ローディング
  nowLoading = true;

  // ページネーター
  @ViewChild(MatPaginator) paginator: MatPaginator;

  // カラム名
  columnDefs = [
    'day',
    'time',
    'userId',
    'serviceName',
    'logText'
  ];

  constructor(private http: HttpClient, private router: Router) { }

  ngOnInit() {
    this.startRecordDay = moment(this.startDay.value).format('YYYY-MM-DD');
  }

  /**
   * 認証切れ（401・403）ならログイン画面へ戻す。それ以外のエラーは呼ぶ側で知らせる
   * @param error HTTP エラー
   * @returns ログイン画面へ戻したら true
   */
  isSignOut(error): boolean {
    if (error && (error.status == 401 || error.status == 403)) {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
      return true;
    }
    return false;
  }

  /**
   * ページ読み込み後の初期化メソッド
   * 前回の絞り込み（localStorage の log_〜）を戻してから取得する
   */
  ngAfterViewInit() {
    this.day = localStorage.getItem('log_day') || "";
    this.time = localStorage.getItem('log_time') || "";
    this.userId = localStorage.getItem('log_user_id') || "";
    this.serviceName = localStorage.getItem('log_service_name') || "";
    this.operation = localStorage.getItem('log_operation') || "";
    this.logText = localStorage.getItem('log_text') || "";

    this.paginator.page.subscribe(() => {
      this.getLogData(this.paginator.pageIndex, this.paginator.pageSize);
    });
    this.getLogData(this.paginator.pageIndex, this.paginator.pageSize);
  }

  /**
   * 記録日（開始日）　変更イベント
   * @param event 開始日
   */
  changeStartDay(event: MatDatepickerInputEvent<Date>) {
    this.paginator.pageIndex = 0;
    this.startDay = new FormControl(event.value);
    this.startRecordDay = this.toDateParam(event.value);
    this.getLogData(this.paginator.pageIndex, this.paginator.pageSize);
  }

  /**
   * 記録日（終了日）　変更イベント
   * @param event 終了日
   */
  changeEndDay(event: MatDatepickerInputEvent<Date>) {
    this.paginator.pageIndex = 0;
    this.endDay = new FormControl(event.value);
    this.endRecordDay = this.toDateParam(event.value);
    this.getLogData(this.paginator.pageIndex, this.paginator.pageSize);
  }

  /**
   * 日付欄の値を API に渡す形（YYYY-MM-DD）に。空・読めない日付は空文字
   * @param value 日付欄の値
   */
  toDateParam(value): string {
    if (!value || !moment(value).isValid()) {
      return '';
    }
    return moment(value).format('YYYY-MM-DD');
  }

  /**
   * ログデータ取得
   * API: GET api/v1/log
   */
  getLogData(index: number, size: number) {
    localStorage.setItem('log_day', this.day);
    localStorage.setItem('log_time', this.time);
    localStorage.setItem('log_user_id', this.userId);
    localStorage.setItem('log_service_name', this.serviceName);
    localStorage.setItem('log_operation', this.operation);
    localStorage.setItem('log_text', this.logText);

    this.nowLoading = true;
    this.http.get(
      API_BASE_URL + '/api/v1/log?index=' + index
      + '&size=' + size
      + '&startDay=' + encodeURIComponent(this.startRecordDay)
      + '&endDay=' + encodeURIComponent(this.endRecordDay)
      + '&error=' + this.error
      + '&day=' + encodeURIComponent(this.day)
      + '&time=' + encodeURIComponent(this.time)
      + '&userId=' + encodeURIComponent(this.userId)
      + '&serviceName=' + encodeURIComponent(this.serviceName)
      + '&operation=' + encodeURIComponent(this.operation)
      + '&logText=' + encodeURIComponent(this.logText),
      {headers: this.headers}
    )
    .subscribe(res => {
      this.logList = new MatTableDataSource(res as Log[]);

      let data = res as any[];
      if (data.length > 0) {
        this.dataSourceLength = data[0].totalSize;
      } else {
        this.dataSourceLength = 0
      }

      this.nowLoading = false;
    },
    error => {
      this.nowLoading = false;
      if (this.isSignOut(error)) return;
      alert("ログの取得に失敗しました。");
    });
  }
}
